<div class="ContentArea p-4" >
    <div class="row">
      <div class="col-md-10">
        <div class="HeadingName" >
          <h2 *ngIf="!isEditMode">Add Company</h2>
          <h2 *ngIf="isEditMode">Update Company Plan</h2>
        </div>
      </div>
      <div *ngIf="isEditMode" class="col-md-2 bcktab">
        <div class="ProfilePik ">
          <a><button class="backButton backbtns " style="font-size: 16px;" (click)="navigateToDashboard()">Back</button></a>
        </div>
      </div>
    </div>
    <div class="row">
      <div *ngIf="!loader">
      <div  class="col-md-6 width46">
        <form [formGroup]="addCP" class="ProfileFor" enctype="multipart/form-data">
          <div class="row">
            <div class="CardPopup" style="background: #e2e5e6;">
              <div class="row">
                <input #fileInput type="file" (change)="readURL($event)" style="display: none" accept="image/*" />
                
                <div class="ChangePic password">
                  <img *ngIf="imageSrc" [src]="imageSrc" [alt]="'logo'" />
                  <span (click)="fileInput.click()" class="Edit_Img">
                    <img src="assets/images/edir-img.png" />
                  </span>
                </div>
                <div *ngIf="isSubmitted && f['logo'].errors" class="text-danger">
                  <div *ngIf="f['logo'].errors['required']" style="    bottom: 20px;
                  position: relative;
                  left: 165px;">Logo is required</div>
                </div>
                <!-- <div (click)="fileInput.click()" class="ChangeImg">
                  Change Profile Photo
                </div> -->
                <!-- <div class="CustomField col-md-12 mb-3">
                  <label>
                    <input type="text" formControlName="name" class="form-control compname" style="font-size: 17px;color: black;
      font-weight: 500;" />
                    <span class="LabelT">Company Name</span>
                  </label>
                  <div *ngIf="isSubmitted && f['name'].errors" class="text-danger">
                    <div *ngIf="f['name'].errors['required']">Company Name is required</div>
                  </div>
                </div> -->
                <div class="col-md-12 mb-3">
                  <span class=" ">
                    <input type="text" formControlName="name" placeholder="Company Name" class="CompanyField" />
                    <div *ngIf="isSubmitted && f['name'].errors" class="text-danger">
                      <div *ngIf="f['name'].errors['required']">
                        Company Name is required
                      </div>
                    </div>
                  </span>
                </div>
                <!-- <div class="col-md-4">
                  <span class="Password">
                    <select formControlName="country" class="Pro_input_Field selectpicker countrypicker">
                      <option value="" disabled selected>Select Country</option>
                      <option *ngFor="let country of countries" [value]="country.name">
                        {{ country.name }}
                      </option>
                    </select>
                    <div *ngIf="isSubmitted && f['country'].errors" class="text-danger">
                      <div *ngIf="f['country'].errors['required']">
                        Country is required
                      </div>
                    </div>
                  </span>
                </div> -->
                <div class="col-md-12 mb-3">
                  <!-- <label> -->
                    <span class=" ">
                    <input type="text" formControlName="address" class="CompanyField" placeholder="Company Address" />
                    <!-- <span class="LabelT">Company Address</span> -->
                  <!-- </label> -->
                  <div *ngIf="isSubmitted && f['address'].errors" class="text-danger">
                    <div *ngIf="f['address'].errors['required']">Company Address is required</div>
                  </div>
                </span>
                </div>
                <!-- <div class="col-md-12">
                  <span class="Password">
                    <input type="text" formControlName="address" placeholder="Company Address" class="form-control compname" />
                    <div *ngIf="isSubmitted && f['address'].errors" class="text-danger">
                      <div *ngIf="f['address'].errors['required']">
                       Company Address is required
                      </div>
                    </div>
                  </span>
                </div> -->
                <div class="col-md-12 mb-3">
                  <span class="">
                    <select formControlName="country" [ngClass]="{
                      'cosct': !addCP.controls['country'].value,
                      'CompanyField': addCP.controls['country'].value
                    }" [(ngModel)]="selectedCountry" (change)="onCountryChange()">
                      <option value="" disabled selected>Select your country</option>
                      <option *ngFor="let country of countrystates" [value]="country.name">{{ country.name }}</option>
                    </select>
                    <div *ngIf="isSubmitted && f['country'].errors" class="text-danger">
                      <div *ngIf="f['country'].errors['required']">
                        Company Country is required
                      </div>
                    </div>
                  </span>
                </div>
  
                <!-- <div class=" CustomField col-md-12 mb-3">
                  <span class="Password dropdown-wrapper" >
                  <label>
                    <select formControlName="country" class="form-control compname" style="font-size: 17px;    color: black;font-weight: 500;" >
                      <option value="" disabled selected>Select your country</option>
                      <option *ngFor="let country of countryCodes" [value]="country.name">{{ country.name }}</option>
                    </select>
                    <span class="LabelT">Company Country</span>
                  </label>
                  <div *ngIf="isSubmitted && f['country'].errors" class="text-danger">
                    <div *ngIf="f['country'].errors['required']">Company Country is required</div>
                  </div>
                </span>
                </div> -->
                <!-- <div class="col-md-12 mb-3" *ngIf="f['country'].value === 'Canada'">
                  <input type="text" id="city" formControlName="canadacity" placeholder="City" class="form-control coucanada">
                  <div *ngIf="isSubmitted && f['canadacity'].errors" class="text-danger">
                    <div *ngIf="f['canadacity'].errors['required']">City is required</div>
                  </div>
                </div>
                <div class="col-md-12 mb-3" *ngIf="f['country'].value === 'Canada'">
                  <input type="text" id="province" formControlName="state" placeholder="Province" class="form-control coucanada">
                  <div *ngIf="isSubmitted && f['state'].errors" class="text-danger">
                    <div *ngIf="f['state'].errors['required']">Province is required</div>
                  </div>
                </div> -->
                <div class=" col-md-12 mb-3 " *ngIf="f['country'].value === 'Canada'">
                  <span class="">
                    <select formControlName="state" [ngClass]="{
                      'cosct': !addCP.controls['country'].value,
                      'CompanyField': addCP.controls['country'].value
                    }">
                      <option value="" disabled selected>Select your Province</option>
                      <option *ngFor="let state of states" [value]="state.name">{{ state.name }}</option>
                    </select>
                    <div *ngIf="isSubmitted && f['state'].errors" class="text-danger">
                      <div *ngIf="f['state'].errors['required']">
                        Province is required
                      </div>
                    </div>
                  </span>
                    <!-- <input type="text" id="province" formControlName="state"  class="CompanyField"  placeholder="Province"/>
                  <div *ngIf="isSubmitted && f['state'].errors" class="text-danger">
                    <div *ngIf="f['state'].errors['required']">Province is required</div>
                  </div> -->
                </div>
                <div class=" col-md-12 mb-3" *ngIf="f['country'].value === 'Canada'">
              
                    <input type="text" id="postalCode" formControlName="postal_code"  class="CompanyField"  placeholder="Postal Code" >
                 
                  <div *ngIf="isSubmitted && f['postal_code'].errors" class="text-danger">
                    <div *ngIf="f['postal_code'].errors['required']">PostalCode is required</div>
                  </div>  
                </div>
                <!-- <div class="col-md-12 mt-3" *ngIf="f['country'].value === 'United States'">
                  <input type="text" id="city" formControlName="usastate" placeholder="State" class="form-control coucanada">
                  <div *ngIf="isSubmitted && f['usastate'].errors" class="text-danger">
                    <div *ngIf="f['usastate'].errors['required']">PostalCode is required</div>
                  </div>
                </div>
                <div class="col-md-12 mt-3" *ngIf="f['country'].value === 'United States'">
                  <input type="text" id="postalCode" formControlName="usazipcode" placeholder="Zipcode" class="form-control coucanada">
                  <div *ngIf="isSubmitted && f['usazipcode'].errors" class="text-danger">
                    <div *ngIf="f['usazipcode'].errors['required']">PostalCode is required</div>
                  </div>
                </div> -->
                <div class="col-md-12 mb-3" *ngIf="f['country'].value !== 'Canada'">
                  <!-- <label> -->
                    <span class="">
                      <select formControlName="state" [ngClass]="{
                        'cosct': !addCP.controls['country'].value,
                        'CompanyField': addCP.controls['country'].value
                      }">
                        <option value="" disabled selected>Select your state</option>
                        <option *ngFor="let state of states" [value]="state.name">{{ state.name }}</option>
                      </select>
                      <div *ngIf="isSubmitted && f['state'].errors" class="text-danger">
                        <div *ngIf="f['state'].errors['required']">
                          Company State is required
                        </div>
                      </div>
                    </span>
                    <!-- <input type="text" formControlName="state"  class="CompanyField"  placeholder="State"/> -->
                    <!-- <span class="LabelT">State</span> -->
                  <!-- </label> -->
                 
                    <!-- <div *ngIf="isSubmitted && f['state'].errors" class="text-danger">
                      <div *ngIf="f['state'].errors['required']">
                       Company State is required
                      </div>
                    </div> -->
              </div>
              <div class="  col-md-12 mb-3" *ngIf="f['country'].value !== 'United States'">
                <span class="Password">
                  <!-- <label> -->
                    <input type="text" formControlName="city"  class="CompanyField"  placeholder="City"/>
                    <!-- <span class="LabelT">City</span>
                  </label>
                   -->
                  <div *ngIf="isSubmitted && f['city'].errors" class="text-danger">
                    <div *ngIf="f['city'].errors['required']">
                     Company City is required
                    </div>
                  </div>
                </span>
              </div>
              <div class=" col-md-12 mb-3" *ngIf="f['country'].value != 'Canada'">
                <span class="Password">
                  <!-- <label> -->
                    <input type="text" formControlName="postal_code" class="CompanyField" placeholder="Zipcode"/>
                    <!-- <span class="LabelT">Zipcode</span>
                  </label> -->
                  
                  <div *ngIf="isSubmitted && f['postal_code'].errors" class="text-danger">
                    <div *ngIf="f['postal_code'].errors['required']">
                     Company Zipcode is required
                    </div>
                  </div>
                </span>
              </div>
                <div class=" col-md-12 mb-3">
                  <span class="Password">
                    <!-- <label> -->
                      <input type="text" formControlName="owner_full_name" class="CompanyField"  placeholder="Company Owner Name"/>
                      <!-- <span class="LabelT">Company Owner Name</span>
                    </label> -->
                   
                    <div *ngIf="isSubmitted && f['owner_full_name'].errors" class="text-danger">
                      <div *ngIf="f['owner_full_name'].errors['required']">
                        Company Owner name required
                      </div>
                    </div>
                  </span>
                </div>
               
            
                <!-- <div class="col-md-6 mt-3">
                  <span class="Password">
                    <input
                      type="text"
                      formControlName="last_name"
                      placeholder="Last Name"
                      class="Pro_input_Field"
                    />
                    <div
                      *ngIf="isSubmitted && f['last_name'].errors"
                      class="text-danger"
                    >
                      <div *ngIf="f['last_name'].errors['required']">
                        Last Name is required
                      </div>
                    </div>
                  </span>
                </div> -->
  
               
  
              
                <!-- <div *ngIf="selectedGroup == 'yes'" [ngClass]="isEditMode ? 'col-md-12':'col-md-12'" class="mt-3">
                  <span class="Password">
                    <input type="text" formControlName="city" placeholder=" Enter City" class="Pro_input_Field" />
                    <div *ngIf="isSubmitted && f['city'].errors" class="text-danger">
                      <div *ngIf="f['city'].errors['required']">
                        City name  is required
                      </div>
                    </div>
                  </span>
                </div> -->
                <div class="col-md-3 mb-3" style="float:left; width:15%; padding-right:6px;">
                  <span class="Password" style="    border: 1px solid #ccd2d8;
                  border-radius: 11px;
                  height: 50px;">
                    <span class="pickup-country" style="width: 100%;">{{addCP.value.country_code}}</span>
                    <select  placeholder="Country" formControlName="country_code"
                      class="CompanyField country-addorder">
                      <option value="" disabled [selected]="true">Country</option>
                      <option *ngFor="let country of countryCodes" [value]="country.dial_code">
                        <span class="mx-3 fw-bold">{{country.name+" "+ country.dial_code }}</span>
                      </option>
                    </select>
                    <div *ngIf="isSubmitted && f['country_code'].errors" class="text-danger">
                      <div *ngIf="f['country_code'].errors['required']">
                        Country is required
                      </div>
                    </div>
                  </span>
                </div>
                <div class=" col-md-9 mb-3" style="float:left; width:85%; padding-left:0;">
          
                    <input type="number" id="phone" formControlName="owner_phone_no"  class="CompanyField"
                      (keypress)="onKeyPress3($event)" (wheel)="onWheel($event)"  placeholder="Company Owner Phone Number"/>
                  <div *ngIf="isSubmitted && f['owner_phone_no'].errors" class="text-danger">
                    <div *ngIf="f['owner_phone_no'].errors['required']">
                      Company Owner number is required
                    </div>
                    <div *ngIf="f['owner_phone_no'].errors['pattern']">
                      Phone number must be 10 digits
                    </div>
                  </div>
                </div>
                <div [ngClass]="isEditMode ? 'col-md-12':'col-md-12'" class=" mb-3">
                    <input type="text" formControlName="owner_email"  class="CompanyField" placeholder="Company Owner Email Address" />
                  <div *ngIf="isSubmitted && f['owner_email'].errors" class="text-danger">
                    <div *ngIf="f['owner_email'].errors['required']">
                      Company Owner Email is required
                    </div>
                    <div *ngIf="f['owner_email'].errors['email']">
                      Email is not valid
                    </div>
                  </div>
                </div>
               
                <!-- <div *ngIf="selectedGroup == 'no'" [ngClass]="isEditMode ? 'col-md-12':'col-md-12'" class="mt-3">
                  <span class="Password">
                    <input type="text" formControlName="owner_email" placeholder="COMPANY OWNER EMAIL ADDRESS" class="Pro_input_Field" />
                    <div *ngIf="isSubmitted && f['owner_email'].errors" class="text-danger">
                      <div *ngIf="f['owner_email'].hasError('required')">
                       Company Owner email is required
                      </div>
                    </div>
                  </span>
                </div> -->
                <div class="col-md-12 mb-3">
                  <span class="Password d-flex">
                    <h3 class="m-0 Pro_input_Field adminName">Are you the Admin?</h3>
                    <div class="form-check">
                      <input (change)="IsAdmin($event)"  type="checkbox" formControlName="are_you_admin">
                    </div>
                  </span>
                </div>
                <div *ngIf="selectedGroup == 'False'" [ngClass]="isEditMode ? 'col-md-12':'col-md-12'" class=" mb-3">
             
                    <input type="text" formControlName="first_name"  class="CompanyField"  placeholder="Super Admin Name"/>
                  <div *ngIf="isSubmitted && f['first_name'].errors" class="text-danger">
                    <div *ngIf="f['first_name'].errors['required']">
                      Super Admin name is required
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedGroup == 'False'" class="col-md-2 mb-3">
                  <span class="Password" style="    border: 1px solid #ccd2d8;
                  border-radius: 11px;
                  height: 50px;">
                    <span class="pickup-country">{{addCP.value.admin_country_code}}</span>
                    <select  placeholder="Country" formControlName="admin_country_code"
                      class="CompanyField country-addorder">
                      <option value="" disabled [selected]="true">Country</option>
                      <option *ngFor="let country of countryCodes" [value]="country.dial_code">
                        <span class="mx-3 fw-bold">{{country.name+" "+ country.dial_code }}</span>
                      </option>
                    </select>
                    <div *ngIf="isSubmitted && f['country_code'].errors" class="text-danger">
                      <div *ngIf="f['country_code'].errors['required']">
                        Country is required
                      </div>
                    </div>
                  </span>
                </div>
                <div *ngIf="selectedGroup == 'False'" class=" col-md-10 mb-3">
                    <input type="number" id="phone" formControlName="phone_number"  class="CompanyField"
                      (keypress)="onKeyPress3($event)" (wheel)="onWheel($event)" placeholder="Super Admin Phone Number" />
                  <div *ngIf="isSubmitted && f['phone_number'].errors" class="text-danger">
                    <div *ngIf="f['phone_number'].errors['required']">
                      Super Admin Phone number is required
                    </div>
                    <div *ngIf="f['phone_number'].errors['pattern']">
                      Phone number must be 10 digits
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedGroup == 'False'" [ngClass]="isEditMode ? 'col-md-12':'col-md-12'" class=" mb-3">
                    <input type="text" formControlName="admin_email"  class="CompanyField"  placeholder="Super Admin Email Address" />
                  <div *ngIf="isSubmitted && f['admin_email'].errors" class="text-danger">
                    <div *ngIf="f['admin_email'].errors['required']">
                      Super Admin Email is required
                    </div>
                    <div *ngIf="f['admin_email'].errors['email']">
                      Admin Email is not valid
                    </div>
                  </div>
                </div>
                <div *ngIf="!isEditMode" class="updtab" >
                  <button  class="Send updtab" (click)="update()">update</button>
                </div>
                <div *ngIf="selectedIndex" class="CardPopup mt-2" style="background: #e2e5e6;">
                  <div *ngIf="isEditMode"  class="card-header">
                    <div class="">
                      <!-- Credit card form tabs -->
                   <ul role="tablist" class="nav bg-light nav-pills rounded nav-fill mb-3" style="list-style:none !important; padding:4px !important; margin-bottom:12px !important; background:#fff !important; border:1px solid #ccd2d8 !important; border-radius:11px !important; display:flex !important;">
  <li (click)="paymentMode('card')" class="nav-item cursor-pointer" style="list-style:none !important; flex:1;">
    <a data-toggle="pill" [ngClass]="selectedPaymentMode == 'card' ? 'p-active':''" class="nav-link" style="border-radius:8px; padding:8px 16px; font-size:0.85rem; text-align:center; display:block; cursor:pointer;">
      <i class="fas fa-credit-card mr-2"></i> Credit Card
    </a>
  </li>
</ul>
                    </div> <!-- End -->
                    <!-- Credit card form content -->
                    <div >
                    <div class="tab-content" *ngIf="selectedPaymentMode == 'card'" >
                      <!-- credit card info-->
                      <div id="credit-card" class="fontSize">
                        <form [formGroup]="creditCardForm" role="form">
                          <div class="form-group"> <label for="username">
                            </label> <input type="text" formControlName="username" name="username" placeholder="Card Owner Name" class="form-control compname">
                          </div>
                          <div *ngIf=" g['username'].errors" class="text-danger">
                            <div *ngIf="isSubmitted && g['username'].errors['required']">
                            Card Owner Name is required
                            </div>
                          </div>
                          <div class="form-group"> <label for="cardNumber">
                            </label>
                            <div class="input-group fontSize"> <input type="number" formControlName="cardNumber" name="cardNumber" placeholder="Valid Card Number"
                                class="form-control compname"(wheel)="onWheel($event)"(keypress)="onKeyPress($event)">
                              <div class="input-group-append"> <span class="input-group-text text-muted"> <i
                                    class="fab fa-cc-visa mx-1 fontSize"></i> <i class="fab fa-cc-mastercard mx-1 fontSize"></i> <i
                                    class="fab fa-cc-amex mx-1 fontSize"></i> </span> </div>
                            </div>
                            <div *ngIf="isSubmitted && g['cardNumber'].errors" class="text-danger">
                              <div *ngIf="g['cardNumber'].errors['required']">
                              Card Number is required
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-8">
                              <div class="form-group"> <label><span class="hidden-xs">
                                  </span></label>
                                <div class="input-group"> <input type="number" formControlName="expirationMonth" placeholder="MM" name="" class="form-control compname"(keypress)="onKeyPress1($event)"
                                  (wheel)="onWheel($event)">
                                  <input type="number" formControlName="expirationYear" placeholder="YY" name="" class="form-control fontSize compname"(keypress)="onKeyPress1($event)"
                                  (wheel)="onWheel($event)">
                                </div>
                                <div *ngIf="isSubmitted && g['expirationMonth'].errors " class="text-danger">
                                  <div *ngIf="g['expirationMonth'].errors['required']">
                                  Month and Year is required
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="form-group mb-3 fontSize "> <label data-toggle="tooltip"
                                  title="Three digit CV code on the back of your card">
                                </label> <input type="number" formControlName="cvv" class="form-control fontSize compname" placeholder="CVV" (keypress)="onKeyPress2($event)"
                                (wheel)="onWheel($event)"> </div>
                            </div>
                            <div *ngIf="isSubmitted && g['cvv'].errors" class="text-danger">
                              <div *ngIf="g['cvv'].errors['required']">
                            <span class="cvv">Cvv is required</span>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-md-12 mt-3">
                            <span class="Password d-flex renew">
                              <h3 class="m-0 Pro_input_Field adminName">Auto Renew  </h3>
                              <div class="form-check">
                                <input (change)="autoRenew($event)"  type="checkbox" formControlName="autorenew">
                              </div>
                            </span>
                          </div>
                          <div class="col-md-12 mt-3">
                            <span class="Password d-flex renew">
                              <h3 class="m-0 Pro_input_Field adminName">Store card data  </h3>
                              <div class="form-check">
                                <input (change)="autoStoreCard($event)"  type="checkbox" formControlName="autostore">
                              </div>
                            </span>
                          </div> -->
                          <!-- <div class="col-md-12 mt-3">
                            <span class="Password d-flex renew">
                              <h3 class="m-0 Pro_input_Field adminName">Join us for Trial <i class="material-icons" style="color:  #4CAF50; font-size: 18px; cursor: pointer;position: relative; top: 5px;"  matTooltip=" By selecting this option, you’ll start a 7-day trial period for $1. After the trial, the full subscription price will be automatically charged unless you cancel before the trial ends. You can cancel anytime during the trial period to avoid further charges.">info</i></h3>
                              <div class="form-check">
                                <input  type="checkbox" (change)="onTrialChange($event)">
                              </div>
                            </span>
                          </div> -->
                          <div class="col-md-12 mt-3">
                            <span class="Password d-flex renew">
                              <h3 class="m-0 Pro_input_Field adminName">Enable Auto Renewal and Store Card Data</h3>
                              <div class="form-check">
                                <input (change)="autoRenewAndStoreCard($event)" type="checkbox"  [checked]="autoReneus" [disabled]="!startTrial">
                              </div>
                            </span>
                          </div>
                        </form>
  
                        
                      </div>
                      
          
          
                      </div>
                      <!-- <div class="card-footer text-right "> <button (click)="handleSubmit()" type="button" class="subscribe p-active btn btn-primary btn-block shadow-sm">
                        {{selectedPaymentMode == 'cash' ? 'Add Company' : 'Confirm Payment'}}</button>
          
                    </div>  -->
                    <div class="card-footer text-right">
                      <button type="button" (click)="selectedPaymentMode === 'cash' ? handleSubmit() :getcardToken()" class="subscribe p-active btn btn-primary btn-block shadow-sm continue" [disabled]="isLoading">
                        <span style="font-size: 14px; margin-top: 8px; height: 50px;">
                          {{ isLoading ? 'Please wait...' : (selectedPaymentMode == 'cash' ? 'Update Plan' : 'Update Plan') }}
                        </span>
                        <i *ngIf="isLoading" class="fa fa-spinner fa-spin" style="font-size: 14px;"></i>
                      </button>
                    </div>
                  </div>
                  </div>
                </div>
               
                <!-- <div *ngIf="selectedGroup == 'no'" [ngClass]="isEditMode ? 'col-md-12':'col-md-12'" class="mt-3">
                  <span class="Password">
                    <input type="text" formControlName="city" placeholder="  City" class="Pro_input_Field" />
                    <div *ngIf="isSubmitted && f['city'].errors" class="text-danger">
                      <div *ngIf="f['city'].errors['required']">
                        City name  is required
                      </div>
                    </div>
                  </span>
                </div> -->
                <!-- <div class="col-md-6 mt-3" *ngIf="!isEditMode">
                  <span class="Password">
                    <input type="text" formControlName="password" placeholder="Password" class="Pro_input_Field" />
                    <div *ngIf="isSubmitted && f['password'].errors" class="text-danger">
                      <div *ngIf="f['password'].errors['required']">
                        Password is required
                      </div>
                    </div>
                  </span>
                </div>
  
                <div class="col-md-12 mt-3">
                  <span class="Password">
                    <textarea formControlName="description" placeholder="Description" class="Pro_input_Field"></textarea>
                    <div *ngIf="isSubmitted && f['description'].errors" class="text-danger">
                      <div *ngIf="f['description'].errors['required']">
                        Description is required
                      </div>
                    </div>
                  </span>
                </div> -->
              </div>
            </div>
          </div>
          <!-- <div class="row mt-2">
            <div class="add-company">
              <div class="d-flex justify-content-between mt-3 Cancel_Save">
                <button routerLink="/superadmin/dashboard" class="CancelButton">
                  Cancel
                </button>
                <button   type="submit" (click)="showPlanSection()" class="SaveButton ButtonStyle">
                  Add Company
                  <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                </button>
              </div>
            </div>
          </div> -->
        </form>
      </div>
  
      <!-- <div class="col-md-4 width37" *ngIf="!isShowPlanSection && !isEditMode">
        <app-sidebar></app-sidebar>
  
      </div> -->
      
      <div  class="col-md-4 width37" *ngIf="isShowPlanSection || isEditMode">
       
  
        <div *ngIf="!loader" class="row" >
          <div class="add-company ">
            <div class="d-flex dropdownvalue">
              <label class="options"  for="dropdown">Select a Plan:</label>
              <select  id="dropdown" [(ngModel)]="selectedOption" name="dropdown" (change)="selectPlan(selectedOption)">
                <option *ngFor="let option of planItems" [value]="option.id">{{ option.title }}</option>
              </select>
            
            </div>
            <!-- <div class="ProfilePik "  style="left: 14px;bottom: 20px; text-align: justify;">
              <a><p class="" style="font-size: 16px; top: 4px; position: relative; font-weight: 500;">or</p></a>
            </div>
            <div class="ProfilePik" 
            style="left: 24px; bottom: 15px; text-align: start; z-index: 10; position: relative;">
         <div (click)="navigateToCreatePlan()" 
              class="underline hover-text cursor-pointer" 
              style="font-size: 16px; top: 4px; display: inline-block; cursor: pointer; white-space: nowrap;">
          <label class="options underline"  for="dropdown"> Create Custom Plan</label>
         </div>
       </div> -->
       
            
            
            
            <div *ngIf="planDetails" class="card responsive-plan-card">
              <!-- <img class="card-img-top" src="assets/images/sper-top-icon02.png" alt="Card image cap"> -->
              <img class="card-img-top" style="border-radius: 50%;" [src]="planDetailss.img ? planDetailss.img : 'assets/images/sper-top-icon02.png'" [alt]="'logo'" />
              <div class="card-body">
                <h4 class="card-title" style="font-family: Roboto,sans-serif;    font-size: 15px; font-weight: 500;">Business Plan:<span style="font-weight: 370; font-family: sans-serif;"> {{ planDetailss.title }}</span></h4>
                <h4 class="card-title" style="font-family: Roboto,sans-serif;    font-size: 15px;font-weight: 500;">Price:<span style="font-weight: 370;font-family: sans-serif;"> ${{planDetailss.price}}</span>  </h4>
                <h4 class="card-title" style="font-family: Roboto,sans-serif;    font-size: 15px;font-weight: 500;">Plan Duration: <span style="font-weight: 370;font-family: sans-serif;">{{planDetailss.valid_for}} {{ planDetailss.valid_for === 1 ? 'Month' : 'Months' }}</span></h4>
                <h4 class="card-title">
                  <table>
                    <!-- <tr>
                        <th>Attribute</th>
                        <th>Value</th>
                    </tr> -->
                    <tr>
                      <td colspan="2"><span style="font-weight: 370; font-size: 1.2rem; display: flex;justify-content: center;    font-size: 15px;">Plan Limit</span></td>
                    </tr>
                    <tr>
                        <td> <span style="font-family: Roboto,sans-serif;    font-size: 15px;    font-weight: 400; font-weight: 500;">Max Admins</span> </td>
                        <td> <span style="font-family: sans-serif;    font-size: 15px;    font-weight: 400;font-style: normal;"> {{ planDetailss.max_admin }}</span></td>
                    </tr>
                    <tr>
                        <td> <span style="font-family: Roboto,sans-serif;    font-size: 15px;font-weight: 400;font-weight: 500;">Max Drivers</span> </td> <!-- Empty cell for spacing -->
                        <td><span style="font-family: sans-serif;    font-size: 15px;    font-weight: 400;font-style: normal;">{{ planDetailss.max_drivers }}</span></td>
                    </tr>
                    <tr>
                      <td> <span style="font-family: Roboto,sans-serif;    font-size: 15px;font-weight: 400;font-weight: 500;">Max Locations</span> </td> <!-- Empty cell for spacing -->
                      <td><span style="font-family: sans-serif;    font-size: 15px;    font-weight: 400;font-style: normal;">{{ planDetailss.location }}</span></td>
                  </tr>
                  <tr>
                    <td> <span style="font-family: Roboto,sans-serif;    font-size: 15px;font-weight: 400; font-weight: 500;">Archived Orders Retained Time</span> </td> <!-- Empty cell for spacing -->
                    <td>
                      <span style="font-family: sans-serif; font-size: 15px; font-weight: 400; font-style: normal;">
                        {{ planDetailss.order_retention_duration }} {{ planDetailss.order_retention_duration === 1 ? 'Month' : 'Months' }}
                      </span>
                    </td>
                </tr>
                </table>
              </h4>
              </div>
            </div>
          
  
  
         
  
            <!-- <input type="hidden" formControlName="plan_id" />
            <div *ngIf="isSubmitted && f['plan_id'].errors" class="text-danger">
              <div *ngIf="f['plan_id'].errors['required']">
                Plan is required
              </div>
              <div *ngIf="f['plan_id'].errors['pattern']">Number Only</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
<!-- <div class="loader-overlay" *ngIf="loader">
  <div class="spinners"></div>
</div> -->